import { t } from "../i18n";
import { getSession } from "../app/auth";

export function PrivacyNotice({ className = "obs-privacy-notice" }: { className?: string }) {
  const url = getSession().privacyUrl;
  return (
    <aside class={className} aria-label={t("privacy.notice.title")}>
      <p class="obs-privacy-title">{t("privacy.notice.title")}</p>
      <p>
        {t("privacy.notice.body")}{" "}
        <a href={url} target="_blank" rel="noreferrer">
          {t("privacy.notice.link")}
        </a>
        .
      </p>
    </aside>
  );
}
